import cn from '../../../../commons/src/libs/class-names'

import {CommonProps, Overwrite} from '../../../../commons/src/types'

import logoCollapsed from '../../assets/images/logo-collapsed.svg'
import logoInvertCollapsed from '../../assets/images/logo-invert-collapsed.svg'
import logoInvert from '../../assets/images/logo-invert.svg'
import logo from '../../assets/images/logo.svg'

type Props = Overwrite<
  CommonProps<'img'>,
  {
    alt?: string
    collapse?: boolean
    invert?: boolean
  }
>

const Logo = ({className, alt, collapse = false, invert = false, ...props}: Props) => {
  const logoMap: {[key: string]: '*.svg'} = {
    default: logo,
    defaultCollapsed: logoCollapsed,
    invert: logoInvert,
    invertCollapsed: logoInvertCollapsed,
  }

  return (
    <img
      {...props}
      className={cn('Logo', {}, className)}
      src={logoMap[`${invert ? 'invert' : 'default'}${collapse ? 'Collapsed' : ''}`]}
      alt={alt}
    />
  )
}

export default Logo
